import { render, staticRenderFns } from "./stageSelect.vue?vue&type=template&id=bd1aae1c&scoped=true&"
import script from "./stageSelect.vue?vue&type=script&lang=ts&"
export * from "./stageSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd1aae1c",
  null
  
)

export default component.exports